
import { toast as sonnerToast } from "sonner";

// Re-export the toast function from sonner
export const toast = sonnerToast;
